import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

type Elevation = 0 | 1 | 2;

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: Elevation;
  padded?: boolean;
  children: ReactNode;
}

export function Card({ elevation = 1, padded = true, style, children, ...rest }: CardProps) {
  const computed: CSSProperties = {
    background: elevation === 2 ? "var(--gt-sys-surface-raised)" : "var(--gt-sys-surface)",
    borderWidth: elevation === 0 ? 1 : 0,
    borderStyle: "solid",
    borderColor: "var(--gt-sys-border)",
    borderRadius: "var(--gt-sys-radius-lg)",
    boxShadow:
      elevation === 0
        ? "none"
        : elevation === 1
          ? "var(--gt-sys-shadow-sm)"
          : "var(--gt-sys-shadow-md)",
    padding: padded ? "var(--gt-sys-space-5)" : 0,
    ...style,
  };
  return (
    <div {...rest} style={computed}>
      {children}
    </div>
  );
}
